/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs */

const en_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realistic mockups`)
};

const ar_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نماذج واقعية`)
};

const bn_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাস্তবসম্মত মকআপ`)
};

const de_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realistische Mockups`)
};

const es_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maquetas realistas`)
};

const fr_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maquettes réalistes`)
};

const pt_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mockups realistas`)
};

const zh_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逼真效果图`)
};

const tr_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçekçi maketler`)
};

const ru_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реалистичные мокапы`)
};

const pl_svc_ai_image_pod_automation_mockups_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realistyczne mockupy`)
};

/**
* | output |
* | --- |
* | "Realistic mockups" |
*
* @param {Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_mockups_title7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Mockups_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_mockups_title7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_mockups_title7(inputs)
	return en_svc_ai_image_pod_automation_mockups_title7(inputs)
});
export { svc_ai_image_pod_automation_mockups_title7 as "svc_ai-image-pod-automation_MOCKUPS_title" }